export default __webpack_public_path__ + "static/media/Ballroll_00373.c7d27935.png";